import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    quote: "Portalplay completely changed how we view content. It's no longer a marketing expense; it's a measurable driver of our enterprise pipeline.",
    author: 'Rennick Solberg',
    role: 'VP of Growth',
    company: 'Vectis Systems'
  }, {
    quote: 'The technical depth they achieve is unmatched. They transformed our generic blog into a thought leadership hub that our target CTOs actually read.',
    author: 'Ondine Kaur',
    role: 'CMO',
    company: 'Helixware'
  }, {
    quote: 'Finally, an agency that speaks the language of revenue. Their attribution framework proved the ROI of our content program within 4 months.',
    author: 'Bastien Thériault',
    role: 'Head of Marketing',
    company: 'Cyphral'
  }];
  return <section className="py-24 bg-slate-50 relative border-y border-slate-200" data-id="element-206">
      <div className="absolute inset-0 bg-grid-pattern opacity-[0.02] pointer-events-none" data-id="element-207"></div>

      <div className="container mx-auto px-6 max-w-7xl relative z-10" data-id="element-208">
        <div className="text-center mb-16" data-id="element-209">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-navy-900" data-id="element-210">
            Trusted by technical leaders.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-211">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-10 border border-slate-200 relative group" data-id="element-212">
              <div className="absolute top-0 right-0 w-16 h-16 bg-slate-50 flex items-center justify-center border-l border-b border-slate-200 group-hover:bg-navy-900 group-hover:text-white transition-colors duration-300" data-id="element-213">
                <Quote size={20} className="text-slate-300 group-hover:text-white" data-id="element-214" />
              </div>

              <p className="text-slate-700 leading-relaxed mb-8 mt-4 relative z-10" data-id="element-215">
                "{testimonial.quote}"
              </p>

              <div className="flex items-center gap-4" data-id="element-216">
                <div className="w-10 h-10 bg-navy-100 flex items-center justify-center font-heading font-bold text-navy-900 text-sm" data-id="element-217">
                  {testimonial.author.charAt(0)}
                </div>
                <div data-id="element-218">
                  <div className="font-heading font-bold text-navy-900 text-sm" data-id="element-219">
                    {testimonial.author}
                  </div>
                  <div className="text-xs text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-220">
                    {testimonial.role}, {testimonial.company}
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}